import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import viewIcn from "../../../../../assets/img/icons/customIcons/view.svg";
import BookingModal from "components/Modals/BookingModal";
import ExpiringRequestsTable from "./ExpiringRequestsTable";

function CompanyExpiringRequestcard({ loader }) {
  const [data, setData] = useState([]);
  const [bookingData, setBookingData] = useState({});
  const [bookingModal, setBookingModal] = useState(false);

  const companyExpiringRequestList = useSelector(
    (state) => state.ExpiringRequestReducer.result
  );

  useEffect(() => {
    setData(companyExpiringRequestList?.booking || []);
  }, [companyExpiringRequestList]);

  const close = () => {
    setBookingModal(false);
  };

  const viewHandler = (dataObj) => {
    console.log("POO", dataObj);
    setBookingData(dataObj);
    setBookingModal(true);
  };

  const viewButton = {
    columnName: "",
    btnTitle: "View",
    type: "actionButton",
    btnTooltip: "View",
    btn: "ViewBooking",
    btnType: "primary",
    btnIcon: viewIcn,
    viewHandler: viewHandler,
  };

  const columns = [
    // { columnName: "Company", columnTag: "bookedCompany", type: "company" },
    { columnName: "Employee ID", columnTag: "empId", type: "text" },
    { columnName: "Designation", columnTag: "designation", type: "text" },
    { columnName: "Date Range", columnTag: "duration", type: "date" },
    { columnName: "Working Days", columnTag: "workingDays", type: "text" },
    {
      columnName: "Days Till Expiry",
      columnTag: "daysTillExpiry",
      type: "calculated",
    },
    // { columnName: "", columnTag: "actions", type: "action" },
  ];

  return (
    <div>
      {data && (
        <ExpiringRequestsTable
          data={companyExpiringRequestList?.booking}
          columns={columns}
          viewButton={viewButton}
          loader={loader}
        />
      )}

      <BookingModal modal={bookingModal} close={close} data={bookingData} />
    </div>
  );
}

export default CompanyExpiringRequestcard;
